import React, { Component } from 'react'
import VideosList from './videos/VideosList'

export default class ContentPane extends Component {
  constructor() {
    super()
    

    this.state = {
      ViewClass: null,
    }
  }

  componentWillMount() {
    this.updateView(this.props.viewParams.view)
  }

  componentWillReceiveProps(newProps) {
    this.updateView(newProps.viewParams.view)
  }
  
  updateView(view) {
    if (this.currentView !== view) {
      this.currentView = view
      switch (view || null) {
        case 'settings':
          import('./settings/Settings')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'payments':
          import('./settings/Payments')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'clipper':
          import('./clipper/Clipper')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'stats':
          import('./stats/Stats')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'joiner':
          import('./joiner/Joiner')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'edit':
          import('./editor/Editor')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'report':
          import('./report/Report')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'buildembed':
          import('./embed/Embed')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'infringement':
          import('./report/DMCA')
          .then(c => this.setState({ViewClass: c.default}))
          break
        case 'videos':
        case null:
        default:
          this.setState({ViewClass: VideosList})
          break
      }
    }
  }

  render() {
    if (!this.state.ViewClass) {
      return (<div />)
    }
    return (
      <this.state.ViewClass
        query={this.props.viewParams.query}
        shortcode={this.props.viewParams.shortcode}
        version={this.props.viewParams.version}
      />
    )
  }
}
